import React, { useEffect } from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import { PageContainer, PageControlSkeleton } from 'src/common';
import { useParams } from 'react-router';
import { MetaSheet } from './comps';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import { useFrameworkControlQuery } from 'src/graphql/_generated';

const ControlLibraryPage = () => {
  const { control_identifier } = useParams<{ control_identifier: string }>();

  const { data } = useFrameworkControlQuery({
    variables: {
      id: control_identifier!,
    },
  });

  const frameworkControl = data?.frameworkControl!;

  const { setLocationPaths } = useActionsApp();

  useEffect(() => {
    if (frameworkControl) {
      setLocationPaths({
        frameworkControl: { id: frameworkControl.id, name: frameworkControl.shortname || frameworkControl.name },
        framework: frameworkControl.controlFramework?.id
          ? {
              id: frameworkControl.controlFramework.id,
              name: frameworkControl.controlFramework.shortname || frameworkControl.controlFramework.name,
            }
          : undefined,
      });
    }
    return () => {
      setLocationPaths({ framework: undefined, frameworkControl: undefined });
    };
  }, [frameworkControl]);

  useGaEventPageView(`Cydea | Control | ${frameworkControl?.shortname}`);

  return (
    <>
      <Meta title={`Cydea | Control | ${frameworkControl?.shortname}`} feedbackScript />
      <PageContainer>
        {frameworkControl ? <MetaSheet data={frameworkControl} /> : <PageControlSkeleton noTable />}
      </PageContainer>
    </>
  );
};

export default ControlLibraryPage;
